export const BUILD_QUOTE_SUCCESS = "BUILD_QUOTE_SUCCESS";
export const BUILD_QUOTE_FAILURE = "BUILD_QUOTE_FAILURE";
export const FETCHING_QUOTES = "FETCHING_QUOTES";